import React, { useEffect, useState } from 'react'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import SupplyOrderItemNameField from './fields/SupplyOrderItemNameField'
import SupplyOrderItemCountField from './fields/SupplyOrderItemCountField'
import UnitMeasureSelectMain from '../../../../form/fields/UnitMeasureSelectMain'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MyButton from '../../../../UI/form/MyButton'
import SupplyOrderItemLinksField from './fields/SupplyOrderItemLinksField'

const SupplyOrderFormItem = ({ index, supplyOrderItem, setValidate, setValueFormItem, deleteItem, isCanDeleted }) => {

	// const [data, setData] = useState(supplyOrderBd ? supplyOrderBd : {}) // Дані з форми
	const [data, setData] = useState(supplyOrderItem ? supplyOrderItem : {}) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [loading, setLoading] = useState(false)

	// const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [result, setResult] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setValidate)
	}, [valid])

	useEffect(() => {
		// console.log('data', data)
		if (data) {
			setValueFormItem(data)
		}
	}, [data])

  return (
    <div className='myFormSimple__listBlock-item'>
		<div className='myFormSimple__listBlock-item-index'>
			{index + 1}
		</div>

		<div className='myFormSimple__listBlock-item-center'>
			<div className='myFormSimple__listBlock-item-flex orderForm__item-flex'>
				{
					formDataProductIsField('name', 'supplyOrderItem') ?
						<SupplyOrderItemNameField
							required={formDataProductRequiredField('name', 'supplyOrderItem')}
							setValidate={e => updateValidate(setValid, 'name', e)}
							setValueForm={e => setValueForm(setData, 'name', e)}
							forciblyValue={data && data.name ? data.name : ''}
						/>
					: ''
				}
				{
					formDataProductIsField('count', 'supplyOrderItem') ?
						<SupplyOrderItemCountField
							required={formDataProductRequiredField('count', 'supplyOrderItem')}
							setValidate={e => updateValidate(setValid, 'count', e)}
							setValueForm={e => setValueForm(setData, 'count', e)}
							forciblyValue={data && data.count ? data.count : ''}
						/>
					: ''
				}
				{
					formDataProductIsField('unitMeasure', 'supplyOrderItem') ?
						<UnitMeasureSelectMain
							required={formDataProductRequiredField('unitMeasure', 'supplyOrderItem')}
							setValidate={e => updateValidate(setValid, 'unitMeasure', e)}
							setValueForm={e => setValueForm(setData, 'unitMeasure', e)}
							forciblyValue={data && data.unitMeasure ? data.unitMeasure : ''}
						/>
					: ''
				}
			</div>
			<div>
				{
					formDataProductIsField('links', 'supplyOrderItem') ?
						<SupplyOrderItemLinksField
							required={formDataProductRequiredField('links', 'supplyOrderItem')}
							setValidate={e => updateValidate(setValid, 'links', e)}
							setValueForm={e => setValueForm(setData, 'links', e)}
							forciblyValue={data && data.links ? data.links : ''}
						/>
					: ''
				}
			</div>
		</div>
		
		{
			isCanDeleted ?
				<MyButton 
					color='red'
					onClick={deleteItem}
				>
					<HighlightOffIcon />
				</MyButton>
			: ''
		}
	</div>
  )
}

export default SupplyOrderFormItem